import React from 'react';
import { UnauthorizedSvg } from './illustrations/unauthorized-svg';

interface UnauthorizedErrorProps {
  message?: string;
}

export const UnauthorizedError: React.FC<UnauthorizedErrorProps> = ({ message }) => {
  return (
    <div className="text-center space-y-6 animate-in fade-in zoom-in-95 duration-500">
      {/* Dynamic SVG Illustration */}
      <div className="flex justify-center my-2">
        <UnauthorizedSvg />
      </div>

      {/* Heading & Subtitle */}
      <div className="space-y-3 max-w-lg mx-auto">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 dark:text-white tracking-tight">
          Session Expired...
        </h1>
        <p className="text-slate-500 dark:text-slate-400 text-sm sm:text-base leading-relaxed">
          {message || "Your session has expired or you need to log in to access this page."}
        </p>
      </div>
    </div>
  );
};

export default UnauthorizedError;
